export default "__VITE_PUBLIC_ASSET__ac6f4b20__"